import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { useUserContext } from '@hooks/context/useUserContext';
import { routes } from '@const/routes';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { apiAccountService } from '@api';
import { useTranslation } from 'react-i18next';

const SecondStepInstantLinkBank = () => {
    const { i18n } = useTranslation();
    const { user } = useUserContext();

    const { data: authToken } = useApiQuery({
        method: () => apiAccountService.getFlinksConnectToken()
    });

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <Typography variant="body2" alignment="center" className={styles.title}>
                XEPPT use Flinks to instantly verify your bank account
            </Typography>
            {authToken && (
                <iframe
                    className="flinksconnect"
                    height="760"
                    style={{ border: 'none' }}
                    src={`${process.env.REACT_APP_FLINKS_URL}${process.env.REACT_APP_FLINKS_PREFIX}lang=${i18n.language}&removePadding=true&headerEnable=false&headerImgEnable=false&authorizeToken=${authToken}&staticLoadingEnable=true&accountSelectorEnable=true&accountSelectorCurrency=cad&consentEnable=false&redirectUrl=${window.location.origin}${routes.link_card_bank}&user=${user?.id}`}
                />
            )}
        </motion.div>
    );
};

export default SecondStepInstantLinkBank;
